import type { Theme } from '../../theme/getTheme';

/** Dark full-screen gradient used by join, invite accept, and auth loading shells. */
export function getJoinFlowGradientColors(t: Theme): readonly [string, string] {
  return [t.background.primary, t.background.shell] as const;
}
